import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight, AlertCircle } from "lucide-react";
import Layout from "../components/Layout";
import StepIndicator from "../components/StepIndicator";
import BackButton from "../components/BackButton";
import Loading from "../components/Loading";
import { listarEspecialidades } from "../lib/api";
import { getBooking, setBooking } from "../lib/bookingState";

const STEPS = ["CPF", "Tipo", "Especialidade", "Profissional", "Horario", "Confirmar"];

export default function AgendarEspecialidade() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const booking = getBooking();

  useEffect(() => {
    if (!booking.patient_id) {
      navigate("/agendar", { replace: true });
      return;
    }

    if (booking.tipo_agendamento !== "consulta") {
      navigate("/agendar/tipo", { replace: true });
      return;
    }

    listarEspecialidades()
      .then(setItems)
      .catch(() => setItems([]));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleSelect(esp) {
    setBooking({
      especialidade_id: esp.id,
      especialidade_nome: esp.nome,
      profissional_id: undefined,
      profissional_nome: undefined,
      data_hora: undefined,
      local_id: undefined,
    });

    navigate("/agendar/profissional");
  }

  return (
    <Layout>
      <BackButton to="/agendar/tipo" />
      <StepIndicator steps={STEPS} current={3} />

      <div className="fade-up">
        <h1
          className="text-2xl sm:text-3xl tracking-tight font-bold text-slate-900"
          style={{ fontFamily: "Manrope" }}
        >
          Qual especialidade?
        </h1>

        {booking.convenio_id ? (
          <p className="text-slate-600 mt-2 text-sm">
             Escolha a especialidade desejada para continuar.
          </p>
        ) : (
          <p className="text-slate-600 mt-2 text-sm">
             Escolha a especialidade desejada para continuar.
          </p>
        )}
      </div>

      {booking.exige_guia && (
        <div className="mt-5 flex items-start gap-2 bg-amber-50 text-amber-800 border border-amber-100 rounded-xl px-4 py-3 text-sm">
          <AlertCircle size={16} className="mt-0.5 shrink-0" />
          <div>{booking.mensagem_guia || "Este convênio exige guia previamente liberada."}</div>
        </div>
      )}

      {items === null ? (
        <Loading label="Carregando especialidades..." />
      ) : items.length === 0 ? (
        <div className="mt-8 text-slate-500 text-sm">
          Nenhuma especialidade disponível para este tipo de atendimento no momento.
        </div>
      ) : (
        <div className="mt-6 space-y-3 fade-up-stagger" data-testid="especialidades-list">
          {items.map((esp) => (
            <button
              key={esp.id}
              data-testid={`especialidade-${esp.id}`}
              onClick={() => handleSelect(esp)}
              className="w-full bg-white border border-slate-200 rounded-2xl p-5 text-left hover:-translate-y-0.5 hover:shadow-md transition-all flex items-center justify-between gap-3"
            >
              <span className="font-medium text-slate-900">{esp.nome}</span>
              <ChevronRight size={18} className="text-slate-400" />
            </button>
          ))}
        </div>
      )}
    </Layout>
  );
}